import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select, MenuItem, InputLabel } from '@material-ui/core';
import mapStateToProps from 'reducers/actions/stateToProps';
import { withSnackbar } from 'notistack';
import './SelectChitTerm.css';
import { SelectChitTermStyle } from './SelectChitTermStyle';
import Constants from 'components/utils/constants';

const getDropdownList = (max = 1) => {
    let terms = []
    terms.push({
        id: -1,
        code: `all`,
        name: `Show All`
    })
    for (let i = max; i >= 1; i--) {
        terms.push({
            id: i,
            code: `term${i}`,
            name: `Term ${i}`
        })
    }
    return terms;
}

class SelectChitTerm extends React.Component {
    constructor(props) {
        super(props);
        this.handleFieldChange = this.handleFieldChange.bind(this)
    }

    state = {
        accounts: [Constants.DEFAULT_ACCOUNT],
    }

    handleFieldChange(e) {
        if (e.target.value === 'unknown') {
            return;
        }
        this.props.onChange(e.target.value);
    }

    render() {
        const { classes, maxTerms } = this.props;
        let terms = getDropdownList(maxTerms)
        return (
            <div className={classes.SelectChitTermContainer}>
                <InputLabel
                    style={{
                        margin: '0px',
                        padding: '0px',
                        marginTop: '3px'
                    }}
                >Term:</InputLabel>
                <Select
                    name="select-term"
                    data-cy="ddTranSelectChitTerm"
                    value={this.props.currentTerm}
                    onChange={this.handleFieldChange}
                    className={'trans-account-select-width'}
                    defaultValue="">
                    {terms.map((term) => 
                        <MenuItem
                            key={`term-${term.id}`}
                            value={term.id}
                            code={term.code}>{term.name}</MenuItem>
                    )}
                </Select>
            </div>
        )
    }
}

SelectChitTerm.propTypes = {
    classes: PropTypes.object.isRequired,
    maxTerms: PropTypes.number.isRequired,
    currentTerm: PropTypes.number.isRequired,
    onReady: PropTypes.func,
    onChange: PropTypes.func,
    caller: PropTypes.string
};

export default connect(mapStateToProps)(withSnackbar(withStyles(SelectChitTermStyle)(SelectChitTerm)));
